import gsap, { Expo, Power2, Power3 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Default from './Default';

export default class Home extends Default {
  
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();

    this._itemsShow = [...GetBy.selector(".card", this.container), ...GetBy.selector(".block-image", this.container)];
  }

  show__effect(__call) {
    this.setupShowHome();
    
    if (this.isFirstTime) {
      Preloader.hide(() => { 
        Wrap.show(() => {
          this.showHome() 
        });
      });
      
    } else {
      if(!this.isBack) Scroll.updateItems();
      Wrap.show(() => { this.showHome() });
    }
  }

  setupShowHome() {
        
    // Creamos el timeline
    this._tl = gsap.timeline({ paused: true });
   

    let delay = this.isFirstTime ? .8 : 0;
    const inc = 0.2;

    for (let i = 0, j = this._itemsShow.length; i < j; i++) {
        const item = this._itemsShow[i];

        if (i < 5) {
            delay = inc * i;

            const distance = Maths.maxminRandom(Metrics.WIDTH * 0.035, Metrics.WIDTH * 0.02);
            const offset = {
                x: Math.random() > 0.5 ? 1 : -1,
                y: Math.random() > 0.5 ? -1 : 1
            };

            gsap.set(item, { x: offset.x * distance, y: offset.y * distance, opacity: 0, force3D: true });

            this._tl.to(item, {
                x: 0,
                duration: 0.8,
                ease: "expo.out"
            }, delay + 0.2);

            this._tl.to(item, {
                y: 0,
                duration: 0.5,
                ease: "expo.out"
            }, delay + 0.1);

            this._tl.to(item, {
                opacity: 1,
                duration: 0.01,
                ease: "power3.in"
            }, delay + 0.1);
        } else {
            gsap.set(item, { opacity: 1 });
        }
    }
  }

  showHome() {
    this.afterShow();
    Scroll.updateItems();
    if (this._tl) this._tl.restart();
  }
}

ControllerPage._addPage("home", Home)
